//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useState, useContext } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { FACEBOOK_SOCIAL_URL, LINKEDIN_SOCIAL_URL, INSTAGRAM_SOCIAL_URL, YOUTUBE_SOCIAL_URL, TIKTOK_SOCIAL_URL } from '../../common/constants';

// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
import { AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { Grid } from '@material-ui/core';

// logo and image
import appStoreImage from '../../images/FooterImg/App_Store_Badge.png';
import googlePlayStoreImage from '../../images/FooterImg/google-play-badge.png';
// import instagram from '../../images/FooterImg/FooterIcon/instagram-icon.png';
// import facebook from '../../images/FooterImg/FooterIcon/facebook-icon.png';
// import pinterest from '../../images/FooterImg/FooterIcon/pinterest-icon.png';
// import twitter from '../../images/FooterImg/FooterIcon/twitter-icon.png';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import YouTubeIcon from '@material-ui/icons/YouTube';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import TiktokIcon from '../../assets/tiktok_logo_4509.svg';

import {
    PATH_HOME,
    PATH_SUB_PAGE_TERMS,
    PATH_SUB_PAGE_PRIVACY,
    PATH_SUB_PAGE_FAQ,
    PATH_EMP_SEARCH,
    PATH_JOB_CENTER,
    PATH_RESOURCE_CENTER,
    PATH_ADVERTISE,
} from '../../system/constants';
import { BASE_URL, HOMEPAGE_FAQ, HOMEPAGE_CONTACT, HOMEPAGE_EMPLOYERS, HOMEPAGE_ABOUT } from '../../common/constants';
import { getCopyrightText } from '../../common/textHelper';

//
//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
// import { useState, useEffect, useContext, useCallback } from 'react';
// import { Modal } from '@material-ui/core';
// import { FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdLink from '../../common/elemental/AfitdLink';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
import LoginDialog from '../../topNav/subComponents/LoginDialog';

// import AfitdTextField from '../../common/elemental/AfitdTextField';

// import fbIcon from '../../images/Modal/fb-icon.png';
// import twitterIcon from '../../images/Modal/twitter-fillicon.png';
// import googleIcon from '../../images/Modal/google-icon.png';
// import AfitdButton from '../../common/elemental/AfitdButton';
// import { Container } from '@material-ui/core';
// import CloseIcon from '@material-ui/icons/Close';
import Logo from '../../system/Logo';

// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    const footerLinkStyles = { color: 'rgba(255, 255, 255, 0.5)', textDecoration: 'none', '&:hover': { textDecoration: 'underline' }, fontSize: 16 };
    return makeStyles(theme => {
        const storeButtonImageStyles = {
            width: '200px',
            height: '58.33px',
            cursor: 'pointer',
            [theme.breakpoints.down('sm')]: { width: '100%', height: 'auto' },
        };
        const storeButtonStyles = { marginRight: 24, marginBottom: 6 };
        const liHeadingStyles = { marginBottom: 10, fontSize: 18 };

        return {
            root: {},
            footerBackground: {
                backgroundColor: '#111E14',
                maxWidth: '100%',
                color: 'white',
                padding: '73px 73px 25px 73px',
                [theme.breakpoints.down('lg')]: { padding: '73px 36px 73px 0px ' },
                [theme.breakpoints.down('md')]: { padding: '40px 0px 60px 0px' },
                [theme.breakpoints.down('sm')]: { padding: '30px 0px 24px 0px' },
            },
            ulContent: { listStyleType: 'none' },
            liContent: { color: 'rgba(255, 255, 255, 0.5)', fontWeight: '300', fontSize: '24px' },
            // footerLogo: { width: '200px', height: '58.33px', cursor: 'pointer', [theme.breakpoints.down('sm')]: { width: '120px', height: '30px' } },
            tiktokIcon: {
                cursor: 'pointer',
                filter: 'invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)',
                margin: '0px 8px',
                // [theme.breakpoints.down('md')]: {
                //     margin: '0px 2px',
                // },
                [theme.breakpoints.down('sm')]: {
                    fontSize: '30px',
                },
            },
            iconContent: {
                fontSize: '35px',
                cursor: 'pointer',
                color: 'rgba(255, 255, 255, 0.5)',
                margin: '0px 8px',
                [theme.breakpoints.down('md')]: {
                    margin: '0px 2px',
                },
                [theme.breakpoints.down('sm')]: {
                    fontSize: '28px',
                },
            },
            footerBottomText: {
                color: 'rgba(255, 255, 255, 0.5)',
                fontWeight: '300',
                fontSize: '14px',
                paddingLeft: '25px',
                marginBottom: 28,
                [theme.breakpoints.down('md')]: { marginLeft: 12, marginBottom: 28 },
                [theme.breakpoints.down('sm')]: { padding: '0px', marginLeft: 28, textAlign: 'left', maxWidth: '100vw' },
            },
            footerBottomLogo: {
                paddingLeft: '42px',
                [theme.breakpoints.down('md')]: { paddingLeft: '40px' },
                [theme.breakpoints.down('sm')]: { flex: 1, paddingLeft: '10px', marginBottom: 12 },
            },
            logo: {
                width: 165,
                height: 47,
            },

            footerBottomContainer: {
                paddingTop: '40px',
                flexDirection: 'row',
                justifyContent: 'sapce-between',
                width: '100%',
                [theme.breakpoints.up('md')]: { alignItems: 'center !important' },
                [theme.breakpoints.down('sm')]: { flexDirection: 'column', paddingRight: 8 },
            },
            footerBottomGrid1: {
                display: 'flex',
                alignItems: 'center',
            },
            footerBottomGrid2: {
                display: 'flex',
                justifyContent: 'space-between',
                marginLeft: '-5px',
                marginBottom: 10,
                textAlign: 'center',
                [theme.breakpoints.down('lg')]: { marginLeft: 0, justifyContent: 'flex-end' },
                [theme.breakpoints.down('md')]: { marginLeft: 0, paddingRight: 24 },
            },
            smFooterBottomGrid1: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginLeft: 20, paddingTop: 36, flexWrap: 'wrap' },
            smFooterBottomGrid2: {
                maxWidth: 200,
                flex: 1,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0px 10px',
                marginBottom: 10,
                marginRight: 10,
                [theme.breakpoints.down('sm')]: { marginBottom: 24, marginLeft: '-10px', marginRight: 0 },
            },
            liHeading: liHeadingStyles,
            liHeadingAFootInTheDoor: { ...liHeadingStyles, minWidth: 180 },
            footerLink: { color: 'white', textDecoration: 'none' }, //'&:hover': { textDecoration: 'underline' }
            footerLinkLi: { ...footerLinkStyles },
            footerLinkLiAdvertise: { ...footerLinkStyles },
            footerLinkLiAbout: { ...footerLinkStyles },
            footerLinkLiEmployers: { ...footerLinkStyles },
            footerLinkLiEmp: { ...footerLinkStyles },
            footerLinkLiJobCenter: { ...footerLinkStyles },
            contactUsLink: { ...footerLinkStyles },
            footerLinkLiResourceCenter: { ...footerLinkStyles },
            footerTopContainer: {
                justifyContent: 'space-between',
                [theme.breakpoints.down('md')]: { justifyContent: 'flex-start', maxWidth: '100vw' },
                [theme.breakpoints.down('sm')]: { marginLeft: -10 },
            },
            footerStoreButtonContainer: { [theme.breakpoints.down('lg')]: { width: '100%', marginRight: 0 } },
            storeButtonContainer: {
                paddingTop: 24,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                [theme.breakpoints.down('md')]: { display: 'flex', justifyContent: 'flex-start', paddingLeft: 38, flexDirection: 'row', boxSizing: 'content-box' },
                [theme.breakpoints.down('sm')]: { justifyContent: 'space-between', padding: '0px 10px', maxWidth: '100vw' },
            },
            appStoreButton: {
                ...storeButtonStyles,
                marginLeft: 0,
                marginRight: 12,
                [theme.breakpoints.down('lg')]: { marginLeft: 0 },
                [theme.breakpoints.down('md')]: { marginLeft: 0 },
                [theme.breakpoints.down('sm')]: { marginLeft: 26 },
            },
            googlePlayStoreButton: {
                ...storeButtonStyles,
                marginRight: 12,
                [theme.breakpoints.down('lg')]: { marginLeft: 0 },
                [theme.breakpoints.down('md')]: { marginLeft: 26 },
                [theme.breakpoints.down('sm')]: { marginLeft: 0, marginRight: 10 },
            },
            appStoreImage: storeButtonImageStyles,
            googlePlayStoreImage: storeButtonImageStyles,

            termsOfUseLink: { ...footerLinkStyles },
            privacyLink: { ...footerLinkStyles },
            faqLink: { ...footerLinkStyles },
            feedBackLi: { color: 'white', fontSize: 18, textDecoration: 'none' },

            paper: {
                position: 'absolute',
                width: 400,
                backgroundColor: theme.palette.background.paper,
                border: '2px solid #000',
                boxShadow: theme.shadows[5],
                padding: theme.spacing(2, 4, 3),
            },
            modalContent: { background: 'white', width: '554px', marginTop: 110, borderRadius: '10px', [theme.breakpoints.down('sm')]: { width: '332px' } },
            logInHeading: { fontSize: 26, fontWeight: 'bold', textAlign: 'center' },
            logInPara: { marginTop: '16px', marginBottom: '32px', textAlign: 'center' },

            continueFbContainer: {
                background: 'rgba(57, 117, 234, 1)',
                width: '474px',
                borderRadius: '4px',
                marginTop: '16px',
                marginBottom: '16px',
                [theme.breakpoints.down('sm')]: { width: '316px' },
            },
            continueFbBtn: {
                width: '474px',
                [theme.breakpoints.down('sm')]: { width: '316px' },
                '&:hover': {
                    background: 'rgba(57, 117, 234, 1)',
                },
                paddingTop: '15px',
                paddingBottom: '15px',
            },
            ContinueText: { fontSize: 16, fontWeight: 700, color: 'white' },
            iconPosition: { position: 'absolute', left: 16 },

            continueTwitterContainer: {
                background: 'rgba(29, 161, 242, 1)',
                width: '474px',
                borderRadius: '4px',
                marginTop: '16px',
                marginBottom: '16px',
                [theme.breakpoints.down('sm')]: { width: '316px' },
            },
            continueTwitterBtn: {
                width: '474px',
                [theme.breakpoints.down('sm')]: { width: '316px' },
                '&:hover': {
                    background: 'rgba(29, 161, 242, 1)',
                },
                paddingTop: '15px',
                paddingBottom: '15px',
            },

            continueGoogleContainer: {
                background: '#FFFFFF',
                width: '474px',
                borderRadius: '4px',
                marginTop: '16px',
                marginBottom: '16px',
                border: '1px solid #D5D7DD',
                [theme.breakpoints.down('sm')]: { width: '316px' },
            },
            continueGoogleBtn: {
                width: '474px',
                [theme.breakpoints.down('sm')]: { width: '316px' },
                '&:hover': {
                    background: '#FFFFFF',
                },
                paddingTop: '15px',
                paddingBottom: '15px',
            },
            ContinueGoogleText: { fontSize: 16, fontWeight: 700, color: 'rgba(0, 0, 0, 0.54)' },

            createWithEmailText: { fontSize: 16, fontWeight: 400, color: '#9B9E9C', marginTop: 8, marginBottom: 24, textAlign: 'center' },

            contactsUsContainer: { textAlign: 'center' },
            radioContainer: { marginLeft: '25px' },
            inputWidth: { maxWidth: '100%', marginTop: '10px', marginBottom: '30px' },
            submitButtonContainer: { marginTop: 38 },
            submitButton: { textTransform: 'capitalize', width: '100%', padding: 17, fontSize: 18, fontWeight: 500 },
            inputPaddingLeft: { paddingLeft: '10px', [theme.breakpoints.down('sm')]: { paddingLeft: 0 } },
            inputPaddingRight: { paddingRight: '10px', [theme.breakpoints.down('sm')]: { paddingRight: 0 } },
            modalStyle1: {
                position: 'absolute',
                top: '10%',
                left: '10%',
                overflow: 'scroll',
                height: '100%',
                display: 'block',
            },
            seeProfileModalStyle: {
                // [theme.breakpoints.down('md')]: { position: 'absolute', top: '10%', left: '10%', overflow: 'scroll', height: '100%', display: 'block' },
            },

            formContainer: { width: '474px', [theme.breakpoints.down('sm')]: { width: '316px' } },
            alreadyAcContainer: { marginTop: 17, marginBottom: 17, textAlign: 'center' },
            alreadyAcText: { fontSize: 16, fontWeight: 500, textDecoration: 'underline' },
            privacyPolicyText: { fontSize: 14, fontWeight: 400 },
            privacyPolicyLink: { fontSize: 14, fontWeight: 400, textDecoration: 'underline' },
            privacyPolicyContainer: { paddingTop: 16, paddingBottom: 40, textAlign: 'center' },
            createAccountLink: { fontSize: 14, fontWeight: 400, textDecoration: 'underline' },
            termsConditionLink: { fontSize: 14, fontWeight: 400, textDecoration: 'underline' },
            checkBoxContainer: { marginLeft: -23 },
            closeIconContainer: { textAlign: 'right', marginTop: 29, marginRight: 29, marginBottom: 9, color: 'rgba(17, 30, 20, 0.4)' },
            createWithEmailItem13: {
                marginBottom: 12,
                paddingRight: 40,
                paddingLeft: 40,
                color: 'rgba(240, 242, 246, 1)',
                [theme.breakpoints.down('sm')]: { maxWidth: '10%', paddingRight: 0, paddingLeft: 0 },
            },
            profileModalContent: {
                background: 'white',
                width: '872px',
                marginTop: 60,
                borderRadius: '10px',
                [theme.breakpoints.down('lg')]: { width: '825px' },
                [theme.breakpoints.down('md')]: { width: '710px', marginBottom: 30 },
                [theme.breakpoints.down('sm')]: { width: '95%' },
            },
            closeIconContent: { cursor: 'pointer' },
            profileContainer: { paddingLeft: 40, paddingRight: 40, [theme.breakpoints.down('md')]: { paddingLeft: 10, paddingRight: 10 } },
            profileName: { fontSize: 20, fontWeight: 'bold', color: ' #111E14;' },
            profileLocation: { fontSize: 20, color: 'rgba(17, 30, 20, 1)', [theme.breakpoints.down('md')]: { fontSize: 16, marginTop: '-14px' } },
            profileAboutMe: { marginBottom: 18 },
            profileOccupation: { marginTop: 39, marginBottom: 14 },
            profileDetails: { fontSize: 14, fontWeight: 400, color: 'rgba(17, 30, 20, 1)' },
            occupationBtn: { color: 'rgba(255, 255, 255, 1)', backgroundColor: '#1D8A8B', padding: '9px 10px', borderRadius: '4px', fontSize: '14px' },
            occupationItem: { marginRight: 8 },
            skillBtn: { color: 'rgba(17, 30, 20, 1)', backgroundColor: 'rgba(240, 242, 246, 1)', padding: '9px 10px', borderRadius: '4px', fontSize: '14px' },
            closeIconContainerProfile: { textAlign: 'right', marginTop: 29, marginRight: 29, color: 'rgba(17, 30, 20, 0.4)' },

            btnLeftIcon: { marginRight: '8px', [theme.breakpoints.down('md')]: { paddingLeft: '0px' } },
            profileBtn: { fontWeight: 'bold', [theme.breakpoints.down('sm')]: { width: '100%' } },
            lastBtnLeftIcon: { marginRight: '8px', [theme.breakpoints.down('md')]: { marginRight: 0 }, [theme.breakpoints.down('sm')]: { marginRight: 8 } },
            profileLastBtn: {
                fontWeight: 'bold',
                paddingRight: 15,
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                color: 'rgba(17, 30, 20, 1)',
                '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)', color: 'rgba(17, 30, 20, 1)' },
                [theme.breakpoints.down('md')]: { paddingRight: 12 },
                [theme.breakpoints.down('sm')]: { width: '100%' },
            },
            lastButtonDiv: { textAlign: 'right', [theme.breakpoints.down('md')]: { textAlign: 'left' } },
            profileQualification: { marginRight: 18, [theme.breakpoints.down('sm')]: { marginRight: '-7px' } },
            profileQualificationHeading: { color: 'rgba(17, 30, 20, 1)', fontWeight: 500, fontSize: 14, [theme.breakpoints.down('sm')]: { fontWeight: 600 } },
            profileQualificationIcon: { width: 16, color: 'rgba(155, 158, 156, 1)', marginTop: 5, marginRight: 12, [theme.breakpoints.down('sm')]: { marginRight: 5 } },
            profileBtnContainer: { paddingBottom: 24, [theme.breakpoints.down('sm')]: { justifyContent: 'center' } },
            blackContainerCircle: {
                position: 'absolute',
                bottom: -5,
                right: '124px',
                [theme.breakpoints.down('lg')]: { right: '83px' },
                [theme.breakpoints.down('md')]: { right: '47px' },
                [theme.breakpoints.down('sm')]: { right: '34px' },
            },
            blackContainerCircleImg: { [theme.breakpoints.down('md')]: { width: 160, height: 80 } },
            circleImageBottomPadding: { paddingBottom: 100, [theme.breakpoints.down('md')]: { paddingBottom: 60 }, [theme.breakpoints.down('sm')]: { paddingBottom: 55 } },
            arrowBack: {
                paddingRight: 16,
                cursor: 'pointer',
                paddingTop: 80,
                [theme.breakpoints.down('md')]: { paddingRight: 0, marginRight: -25, zIndex: 1 },
            },
            arrowBackImg: {
                [theme.breakpoints.down('md')]: { width: 40, height: 40 },
                [theme.breakpoints.down('sm')]: { position: 'absolute', top: 145, left: 55, width: 40, height: 40 },
            },
            arrowForward: {
                paddingLeft: 16,
                cursor: 'pointer',
                paddingTop: 80,
                [theme.breakpoints.down('md')]: { paddingLeft: 0, marginLeft: -25, zIndex: 1 },
            },
            arrowForwardImg: {
                [theme.breakpoints.down('md')]: { width: 40, height: 40 },
                [theme.breakpoints.down('sm')]: { position: 'absolute', top: 145, right: 55, width: 40, height: 40 },
            },
            fieldLevel: { fontWeight: 'bold' },
            profileBtnAndAboutContainer: {
                [theme.breakpoints.down('sm')]: {
                    paddingTop: 10,
                    height: 395,
                    overflowY: 'scroll',
                    overflowX: 'hidden',
                    '&::-webkit-scrollbar-track': {
                        borderRadius: '10px',
                        background: 'none',
                    },
                    '&::-webkit-scrollbar': {
                        width: '8px',
                        backgroundColor: '#F5F5F5',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        borderRadius: '10px',
                        backgroundColor: 'rgba(0,0,0,0.2)',
                    },
                },
            },
            profileAboutMeSection: {
                marginTop: 27,
                [theme.breakpoints.up('md')]: {
                    height: 250,
                    overflowY: 'scroll',
                    overflowX: 'hidden',
                    '&::-webkit-scrollbar-track': {
                        borderRadius: '10px',
                        background: 'none',
                    },
                    '&::-webkit-scrollbar': {
                        width: '8px',
                        backgroundColor: '#F5F5F5',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        borderRadius: '10px',
                        backgroundColor: 'rgba(0,0,0,0.2)',
                    },
                },
            },
            mainContainer: {
                padding: '0 60px',
                [theme.breakpoints.down('sm')]: { padding: '0 10px' },
                [theme.breakpoints.up('xl')]: { padding: '0 120px' },
                [theme.breakpoints.only('lg')]: { padding: '0 44px' },
            },
            img: { width: '100%' },
            profileTwoButton: { direction: 'row', [theme.breakpoints.down('md')]: { justifyContent: 'center', alignItems: 'center', textAlign: 'center' } },
            profileQualificationContent: { [theme.breakpoints.down('sm')]: { justifyContent: 'center', marginTop: '-28px' } },
            profileContent2Div: { [theme.breakpoints.down('sm')]: { textAlign: 'center' } },
            profileContent1: { [theme.breakpoints.down('sm')]: { textAlign: 'center' } },
            profileButtons01: { [theme.breakpoints.down('sm')]: { marginTop: '-8px' } },
            profileButtons02: { [theme.breakpoints.down('sm')]: { paddingTop: 16 } },
            profileBtnContent2: { [theme.breakpoints.down('sm')]: { paddingTop: 16 } },
            bannerParagraph: {
                fontSize: 20,
                color: 'rgba(255, 255, 255, 0.8)',
                paddingBottom: 40,
            },
            resumeCardParagraph: { fontSize: 18 },
        };
    });
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        history,
        setIsLogin,
        loginModalOpen,
        handleCloseLoginModal,
        hideJS,
        hideEmp,
        handleClickAppStoreButton,
        handleClickGooglePlayStoreButton,
        // mdMatches,
        smMatches,
    } = params;

    const defns = {
        footerBottomContainer: { container: true },
        footerBottomGrid1: { item: true, xl: 9, lg: 9, md: 9, sm: 6, xs: 6 },
        footerBottomGrid2: { item: true, xl: 3, lg: 3, md: 3, sm: 6, xs: 6 },
        footerTopContainer: { container: true, direction: 'row' },
        footerTopContent: { item: true, xl: 2, lg: 2, md: 3, sm: 6, xs: 6 },
        footerStoreButtonContainer: { item: true, xl: 2, lg: 4, md: 10, sm: 10, xs: 12 },
        storeButtonContainer: { container: true },
        appStoreButton: { item: true, xl: 12, lg: 12, md: 4, sm: 5, xs: 4, onClick: handleClickAppStoreButton },
        googlePlayStoreButton: { item: true, xl: 12, lg: 12, md: 4, sm: 5, xs: 4, onClick: handleClickGooglePlayStoreButton },
        faqLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_FAQ}/${PATH_SUB_PAGE_FAQ}`),
        },
        footerLinkLiEmp: {
            onClick: handleClickButton.bind(null, history, `${BASE_URL}${PATH_EMP_SEARCH}`),
        },
        footerLinkLiJobCenter: {
            onClick: handleClickButton.bind(null, history, `${BASE_URL}${PATH_JOB_CENTER}`),
        },
        footerLinkLiResourceCenter: {
            onClick: handleClickButton.bind(null, history, `${BASE_URL}${PATH_RESOURCE_CENTER}`),
        },
        footerLinkLiAdvertise: {
            onClick: handleClickButton.bind(null, history, `${BASE_URL}${PATH_ADVERTISE}/intro`),
        },
        footerLinkLiAbout: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_ABOUT}`),
        },
        footerLinkLiEmployers: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_EMPLOYERS}`),
        },
        termsOfUseLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_FAQ}/${PATH_SUB_PAGE_TERMS}`),
        },
        privacyLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_FAQ}/${PATH_SUB_PAGE_PRIVACY}`),
        },
        contactUsLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_CONTACT}`),
        },

        modalContainer: { container: true, direction: 'row', justify: 'center', alignItems: 'center' },
        modalContent: { item: true },
        continueFb: { container: true, direction: 'row', justify: 'center' },
        continueFbContent: { item: true },

        contactsFormSection: { container: true, direction: 'row', justify: 'center' },
        contactsFormGrid: { item: true },
        formInputContainer: { container: true },
        formInputItem: { item: true, lg: 6, md: 6, sm: 12, xs: 12 },
        formMainGrid: { container: true, direction: 'row', justify: 'center' },
        formMainGridItem: { item: true },
        createWithEmailContainer: { container: true, direction: 'row', justify: 'center', alignItems: 'center' },
        createWithEmailItem2: { item: true, lg: 6, md: 6, sm: 8, xs: 8 },
        createWithEmailItem13: { item: true, lg: 3, md: 3, sm: 4, xs: 4 },
        profileContainer: { container: true, direction: 'row', justify: 'center' },
        profileContent1: { item: true, lg: 2, md: 2, sm: 12, xs: 12 },
        profileContent2: { item: true, lg: 10, md: 10, sm: 12, xs: 12 },
        occupationContainer: { container: true, direction: 'row' },
        occupationItem: { item: true },
        profileBtnContainer: { container: true, direction: 'row' },
        profileBtnContent1: { item: true, lg: 8, md: 8, sm: 12, xs: 12 },
        profileBtnContent2: { item: true, lg: 4, md: 4, sm: 12, xs: 12 },
        profileQualificationContent: { container: true, direction: 'row' },
        profileQualification: { item: true },

        profileQualificationIconContainer: { container: true, direction: 'row', alignItems: 'center' },
        profileQualificationIconContent: { item: true },
        profileTwoButton: { container: true },
        profileButtons01: { item: true, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 },
        profileButtons02: { item: true, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 },

        alreadyAcText: {
            color: 'secondary',
            onClick: () => {
                setIsLogin(true);
            },
        },
        createAccountLink: {
            color: 'secondary',
            onClick: () => {
                setIsLogin(false);
            },
        },
        termsConditionLink: {
            color: 'secondary',
            // onClick: () => {
            //     setIsLogin(false);
            // },
        },
        privacyPolicyLink: {
            color: 'secondary',
            // onClick: () => {
            //     setIsLogin(false);
            // },
        },
        loginDialog: {
            open: loginModalOpen,
            isLoginMode: false,
            noLogin: true,
            onClose: handleCloseLoginModal,
            hideJS,
            hideEmp,
        },
        tiktokIcon: { src: TiktokIcon, width: smMatches ? '24px' : '28px' },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const handleClickButton = (history, path) => {
    history.push(`${BASE_URL}${path}`);
};

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const Footer = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();
    const history = useHistory();

    const appContext = useContext(AppContext);
    const { sys } = appContext;
    const appStoreUrl = sys?.appStoreUrl;
    const googlePlayStoreUrl = sys?.googlePlayStoreUrl;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    const theme = useTheme();
    const mdMatches = useMediaQuery(theme.breakpoints.down('md'));
    const smMatches = useMediaQuery(theme.breakpoints.down('sm'));

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);
    const [hideJS, setHideJS] = React.useState(false);
    const [hideEmp, setHideEmp] = React.useState(false);
    // radio group MIU
    // const [value, setValue] = useState('Job Seeker');

    // const [isBlack, setIsBlack] = useState(true);

    // login or register modal
    const [loginModalOpen, setLoginModalOpen] = useState(false);

    // const [isLogin, setIsLogin] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    // const handleChange = event => {
    //     setValue(event.target.value);
    // };
    const handleOpenLoginModal = () => {
        setLoginModalOpen(true);
        setHideJS(false);
        setHideEmp(true);
    };

    const handleOpenLoginModalForEmp = () => {
        setLoginModalOpen(true);
        setHideJS(true);
        setHideEmp(false);
    };

    const handleCloseLoginModal = () => {
        setLoginModalOpen(false);
    };

    const handleClickIcons = url => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const handleClickAppStoreButton = () => {
        window.open(appStoreUrl, '_blank', 'noopener,noreferrer');
    };

    const handleClickGooglePlayStoreButton = () => {
        window.open(googlePlayStoreUrl, '_blank', 'noopener,noreferrer');
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({
        classes,
        props,
        history,
        loginModalOpen,
        handleCloseLoginModal,
        hideJS,
        hideEmp,
        handleClickAppStoreButton,
        handleClickGooglePlayStoreButton,
        mdMatches,
        smMatches,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Grid {...defns.footerBackground}>
            <Grid {...defns.footerTopContainer}>
                <Grid {...defns.footerTopContent}>
                    <ul {...defns.ulContent}>
                        <li {...defns.liHeading}>
                            <p {...defns.footerLink}>For Job Seekers</p>
                        </li>
                        <span {...defns.liContent}>
                            <li>
                                <AfitdLink {...defns.footerLinkLi} onClick={handleOpenLoginModal}>
                                    Create an Account
                                </AfitdLink>
                            </li>
                            <li>
                                <AfitdLink {...defns.footerLinkLiEmp}>Search Employers</AfitdLink>
                            </li>
                            <li>
                                <AfitdLink {...defns.footerLinkLiJobCenter}>Search Jobs</AfitdLink>
                            </li>
                            <li>
                                <AfitdLink {...defns.footerLinkLiResourceCenter}>Resource Center</AfitdLink>
                            </li>
                        </span>
                    </ul>
                </Grid>
                <Grid {...defns.footerTopContent}>
                    <ul {...defns.ulContent}>
                        <li {...defns.liHeading}>
                            <p {...defns.footerLink}>For Employers</p>
                        </li>
                        <span {...defns.liContent}>
                            <li>
                                <AfitdLink {...defns.footerLinkLiEmployers}>Employers Page</AfitdLink>
                            </li>
                            <li>
                                <AfitdLink {...defns.footerLinkLi} onClick={handleOpenLoginModalForEmp}>
                                    Create an Account
                                </AfitdLink>
                            </li>
                            {/* <li>
                                <AfitdLink {...defns.footerLinkLiAdvertise}>Advertise With Us</AfitdLink>
                            </li> */}
                        </span>
                    </ul>
                </Grid>

                <Grid {...defns.footerTopContent}>
                    <ul {...defns.ulContent}>
                        <li {...defns.liHeadingAFootInTheDoor}>
                            <p {...defns.footerLink}>A Foot in the Door</p>
                        </li>
                        <span {...defns.liContent}>
                            <li>
                                <AfitdLink {...defns.footerLinkLiAbout}>About</AfitdLink>
                            </li>

                            <li>
                                <AfitdLink {...defns.termsOfUseLink}>Terms of Use</AfitdLink>
                            </li>
                            <li>
                                <AfitdLink {...defns.privacyLink}>Privacy Policy</AfitdLink>
                            </li>
                            <li>
                                <AfitdLink {...defns.contactUsLink}>Contact Us</AfitdLink>
                            </li>
                            {/* <li>
                                <AfitdLink {...defns.faqLink}>FAQ</AfitdLink>
                            </li> */}
                            {/* <li>
                                <AfitdLink {...defns.footerLinkLiAdvertise}>Advertise With Us</AfitdLink>
                            </li> */}
                        </span>
                    </ul>
                </Grid>
                {/* footer */}
                <Grid {...defns.ulContent} {...defns.footerStoreButtonContainer}>
                    <Grid {...defns.storeButtonContainer}>
                        <Grid {...defns.appStoreButton}>
                            <img {...defns.appStoreImage} src={appStoreImage} alt="" />
                        </Grid>
                        <Grid {...defns.googlePlayStoreButton}>
                            <img {...defns.googlePlayStoreImage} src={googlePlayStoreImage} alt="" />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            {/* footer bottom section */}
            {smMatches ? (
                <Grid {...defns.footerBottomContainer}>
                    <div {...defns.smFooterBottomGrid1}>
                        <div {...defns.footerBottomLogo}>
                            <Logo {...defns.logo} />
                        </div>
                        <div {...defns.smFooterBottomGrid2}>
                            <img alt="TikTok Icon" {...defns.tiktokIcon} onClick={() => handleClickIcons(TIKTOK_SOCIAL_URL)} />
                            <InstagramIcon {...defns.iconContent} onClick={() => handleClickIcons(INSTAGRAM_SOCIAL_URL)} />
                            <FacebookIcon {...defns.iconContent} onClick={() => handleClickIcons(FACEBOOK_SOCIAL_URL)} />
                            <LinkedInIcon {...defns.iconContent} onClick={() => handleClickIcons(LINKEDIN_SOCIAL_URL)} />
                            <YouTubeIcon {...defns.iconContent} onClick={() => handleClickIcons(YOUTUBE_SOCIAL_URL)} />
                        </div>
                    </div>
                    <div {...defns.footerBottomText}>{getCopyrightText()}</div>
                </Grid>
            ) : mdMatches ? (
                <Grid {...defns.footerBottomContainer}>
                    <Grid {...defns.footerBottomGrid1}>
                        <div {...defns.footerBottomLogo}>
                            <Logo {...defns.logo} />
                        </div>
                    </Grid>
                    <Grid {...defns.footerBottomGrid2} spacing={3}>
                        <img alt="TikTok Icon" {...defns.tiktokIcon} onClick={() => handleClickIcons(TIKTOK_SOCIAL_URL)} />
                        <InstagramIcon {...defns.iconContent} onClick={() => handleClickIcons(INSTAGRAM_SOCIAL_URL)} />
                        <FacebookIcon {...defns.iconContent} onClick={() => handleClickIcons(FACEBOOK_SOCIAL_URL)} />
                        <LinkedInIcon {...defns.iconContent} onClick={() => handleClickIcons(LINKEDIN_SOCIAL_URL)} />
                        <YouTubeIcon {...defns.iconContent} onClick={() => handleClickIcons(YOUTUBE_SOCIAL_URL)} />
                    </Grid>
                    <p {...defns.footerBottomText}>{getCopyrightText()}</p>
                </Grid>
            ) : (
                <Grid {...defns.footerBottomContainer}>
                    <Grid {...defns.footerBottomGrid1}>
                        <div {...defns.footerBottomLogo}>
                            <Logo {...defns.logo} />
                        </div>
                        <p {...defns.footerBottomText}>{getCopyrightText()}</p>
                    </Grid>
                    <Grid {...defns.footerBottomGrid2} spacing={3}>
                        <img alt="TikTok Icon" {...defns.tiktokIcon} onClick={() => handleClickIcons(TIKTOK_SOCIAL_URL)} />
                        <InstagramIcon {...defns.iconContent} onClick={() => handleClickIcons(INSTAGRAM_SOCIAL_URL)} />
                        <FacebookIcon {...defns.iconContent} onClick={() => handleClickIcons(FACEBOOK_SOCIAL_URL)} />
                        <LinkedInIcon {...defns.iconContent} onClick={() => handleClickIcons(LINKEDIN_SOCIAL_URL)} />
                        <YouTubeIcon {...defns.iconContent} style={{ fontSize: '37px' }} onClick={() => handleClickIcons(YOUTUBE_SOCIAL_URL)} />
                    </Grid>
                </Grid>
            )}
            {/* create account modal */}

            {/* ================== Login/Register Modal Section ================== */}
            <LoginDialog {...defns.loginDialog} />
        </Grid>
    );
};

export default Footer;
